import http from '../../plugins/axios';

export default {

    /**
     * 获取栏目列表
     * @param data
     * @returns {*}
     */
    getColumnList(data) {
        return http.get({
            url: '/cms/cms/column/list',
            data
        })
    },

    /**
     * 增加栏目
     * @param data
     * @returns {*}
     */
    addColumn(data) {
        return http.post({
            url: '/cms/cms/column/add',
            data,
            dataType: 'form'
        })
    },

    /**
     * 修改栏目
     * @param data
     * @returns {*}
     */
    updateColumn(data) {
        return http.post({
            url: '/cms/cms/column/update',
            data,
            dataType: 'form'
        })
    },

    /**
     * 修改栏目
     * @param data
     * @returns {*}
     */
    deleteColumn(data) {
        return http.post({
            url: '/cms/cms/column/delete',
            data,
            dataType: 'form'
        })
    },

    /**
     * 显示或隐藏
     * @param data
     * @returns {*}
     */
    showOrHide(data) {
        return http.post({
            url: '/cms/cms/column/showOrHide',
            data,
            dataType: 'form'
        })
    },

    /**
     * 获取标签列表
     * @param data
     * @returns {*}
     */
    getLabelList(data) {
        return http.get({
            url: '/cms/cms/label/list',
            data
        })
    },

    /**
     * 增加标签
     * @param data
     * @returns {*}
     */
    addLabel(data) {
        return http.post({
            url: '/cms/cms/label/add',
            data,
            dataType: 'form'
        })
    },

    /**
     * 修改标签
     * @param data
     * @returns {*}
     */
    updateLabel(data) {
        return http.post({
            url: '/cms/cms/label/update',
            data,
            dataType: 'form'
        })
    },

    /**
     * 删除标签
     * @param data
     * @returns {*}
     */
    deleteLabel(data) {
        return http.post({
            url: '/cms/cms/label/delete',
            data,
            dataType: 'form'
        })
    },

    /**
     * 导入标签
     * @param data
     * @returns {*}
     */
    importLabel(data) {
        return http.post({
            url: '/cms/cms/label/import',
            data,
            dataType: 'form'
        })
    },

    /**
     * 增加文章或资讯
     * @param data
     * @returns {*}
     */
    addNews(data) {
        return http.post({
            url: '/cms/cms/news/add',
            data
        })
    },

    /**
     * 发布/修改文章或资讯
     * @param data
     * @returns {*}
     */
    publishNewsSimplify(data) {
        return http.post({
            url: '/cms/cms/review/publishSimplify',
            data
        })
    },

    /**
     * 获取文章或资讯列表
     * @param data
     * @returns {*}
     */
    getWaitNewsList(data) {
        return http.get({
            url: '/cms/cms/review/list',
            data
        })
    },

    /**
     * 获取文章/资讯详情
     * @param data
     * @returns {*}
     */
    getNewsDetail(data) {
        return http.get({
            url: '/cms/cms/review/detail',
            data
        })
    },

    /**
     * 获取文章/资讯id列表
     * @param data
     * @returns {*}
     */
    getNewsIdList(data) {
        return http.get({
            url: '/cms/cms/review/ids',
            data
        })
    },

    /**
     * 发布文章/资讯
     * @param data
     * @returns {*}
     */
    publishNews(data) {
        return http.post({
            url: '/cms/cms/review/publish',
            data,
            dataType: 'form'
        })
    },

    /**
     * 修改文章/资讯审核结果
     * @param data
     * @returns {*}
     */
    updateNewsReview(data) {
        return http.post({
            url: '/cms/cms/review/update',
            data,
            dataType: 'form'
        })
    },

    /**
     * 置顶
     * @param data
     * @returns {*}
     */
    newsTopping(data) {
        return http.post({
            url: '/cms/cms/review/topping',
            data,
            dataType: 'form'
        })
    },

    /**
     * 推荐
     * @param data
     * @returns {*}
     */
    newsRecommend(data) {
        return http.post({
            url: '/cms/cms/review/recommend',
            data,
            dataType: 'form'
        })
    },

    /**
     * 删除资讯
     * @param data
     * @returns {*}
     */
    deleteNews(data) {
        return http.post({
            url: '/cms/cms/review/news/delete',
            data,
            dataType: 'form'
        })
    },

    /**
     * 获取推荐位列表
     * @param data
     * @returns {*}
     */
    getRecommendPositionList(data) {
        return http.get({
            url: '/cms/cms/recommend/position/list',
            data
        })
    },

    /**
     * 获取推荐位类型
     * @param data
     * @returns {*}
     */
    getRecommendPositionTypes(data) {
        return http.get({
            url: '/cms/cms/recommend/position/types',
            data
        })
    },

    /**
     * 新增推荐位
     * @param data
     * @returns {*}
     */
    addRecommendPosition(data) {
        return http.post({
            url: '/cms/cms/recommend/position/add',
            data,
            dataType: 'form'
        })
    },

    /**
     * 修改推荐位
     * @param data
     * @returns {*}
     */
    updateRecommendPosition(data) {
        return http.post({
            url: '/cms/cms/recommend/position/update',
            data,
            dataType: 'form'
        })
    },

    /**
     * 推荐位下推或上推
     * @param data
     * @returns {*}
     */
    deleteRecommendPosition(data) {
        return http.post({
            url: '/cms/cms/recommend/position/delete',
            data,
            dataType: 'form'
        })
    },

    /**
     * 新增推荐项
     * @param data
     * @returns {*}
     */
    addRecommendItem(data) {
        return http.post({
            url: '/cms/cms/recommend/item/add',
            data,
            dataType: 'form'
        })
    },

    /**
     * 修改推荐项
     * @param data
     * @returns {*}
     */
    updateRecommendItem(data) {
        return http.post({
            url: '/cms/cms/recommend/item/update',
            data,
            dataType: 'form'
        })
    },

    /**
     * 推荐项是否可用
     * @param data
     * @returns {*}
     */
    recommendItemActivated(data) {
        return http.post({
            url: '/cms/cms/recommend/item/active',
            data,
            dataType: 'form'
        })
    },

    /**
     * 获取推荐项列表
     * @param data
     * @returns {*}
     */
    getRecommendItemList(data) {
        return http.get({
            url: '/cms/cms/recommend/item/list',
            data
        })
    },

    /**
     * 获取币种列表
     * @param data
     * @returns {*}
     */
    getCoinList(data) {
        return http.get({
            url: '/cms/cms/recommend/coin/list',
            data
        })
    },

    /**
     * 修改币种标签
     * @param data
     * @returns {*}
     */
    updateCoinabel(data) {
        return http.post({
            url: '/cms/cms/recommend/coin/label/update',
            data,
            dataType: 'form'
        })
    },

    /**
     * 获取可用交易对
     * @param data
     * @returns {*}
     */
    getAllSupportingPairs(data) {
        return http.get({
            url: '/cms/cms/review/pair',
            data
        })
    },

    /**
     * 理财产品列表
     * @param data
     * @returns {*}
     */
    getFinancialList(data) {
        return http.get({
            url: '/cms/cms/review/financial',
            data
        })
    },

    /**
     * 产品标签库，同步所有币种生成产品标签
     * @param data
     * @returns {*}
     */
    syncCoinToLabel(data) {
        return http.post({
            url: '/cms/cms/label/sync',
            data,
            dataType: 'form'
        })
    },

    /**
     * 同步币种标签到币种
     * @param data
     * @returns {*}
     */
    syncLabelToCoin(data) {
        return http.post({
            url: '/cms/cms/recommend/coin/sync',
            data,
            dataType: 'form'
        })
    },
    deleteRepeatNews(data){
        return http.post({
            url: '/cms/cms/api/delete/repeat',
            data,
            dataType: 'form'
        })
    },
    getUserInfoList() {
        return http.get({
            url : '/admin/auth/userList'
        })
    },
    getStatisticsData(data){
        return http.get({
            url: '/cms/cms/statistics/news/data',
            data
        })
    }
}
